import { render, staticRenderFns } from "./MyOdds.vue?vue&type=template&id=5a67179a&scoped=true"
import script from "./MyOdds.vue?vue&type=script&lang=js"
export * from "./MyOdds.vue?vue&type=script&lang=js"
import style0 from "./MyOdds.vue?vue&type=style&index=0&id=5a67179a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67179a",
  null
  
)

export default component.exports